"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Typography = _interopRequireDefault(require("../../../Typography"));
var _utils = require("../../utils");
var _ButtonBase = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _styles = require("@mui/material/styles");
var _styles2 = require("@mui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["month", "className", "disabled", "focused", "selected", "tabIndex", "onFocus"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = "Month";
var useStyles = (0, _styles2.makeStyles)(function (theme) {
  return {
    button: {
      width: 60,
      height: 40,
      borderRadius: 20,
      padding: 10,
      "&:hover": {
        backgroundColor: (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
      },
      "&:focus": {
        backgroundColor: (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
      }
    },
    selected: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark
      },
      "&:focus": {
        backgroundColor: theme.palette.primary.dark
      }
    },
    disabled: {
      pointerEvents: "none",
      color: theme.palette.text.disabled
    }
  };
});
var Month = function Month(_ref) {
  var month = _ref.month,
    className = _ref.className,
    disabled = _ref.disabled,
    focused = _ref.focused,
    selected = _ref.selected,
    tabIndex = _ref.tabIndex,
    onFocus = _ref.onFocus,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (focused && !disabled && ref.current) {
      ref.current.focus();
    }
  }, [disabled, focused]);
  var handleFocus = (0, _react.useCallback)(function (e) {
    if (!focused && onFocus) {
      onFocus(e);
    }
  }, [focused, onFocus]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonBase["default"], _objectSpread(_objectSpread({
    "dara-cy": dataCy,
    className: (0, _clsx2["default"])(classes.button, _defineProperty(_defineProperty({}, classes.selected, selected), classes.disabled, disabled)),
    disabled: disabled,
    tabIndex: tabIndex,
    ref: ref,
    onFocus: handleFocus
  }, props), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
      variant: "body2",
      children: (0, _utils.format)(month, "LLL")
    })
  }));
};
var _default = exports["default"] = Month;